import { DefaultService as ProductivityIntegrationsSDK } from '@atbay/productivity-integrations-node-sdk'
import { createClient } from '@core/base/http-client'

export const ProductivityIntegrationsClient = createClient(
    // @ts-ignore
    ProductivityIntegrationsSDK
)
